/*Profile*/
if(window.location.pathname.includes("placement/documents")){
    $(document).ready(function() {
        $(window).on("resize", resize_viewport);
        resize_viewport();
        $("#filemanager-display").attr("src", "/tps-filemanager?id="+app.placement.id+"&type=housing");
    });

    function resize_viewport() {
        var height = $(window).innerHeight()-($(".navbar-tps").outerHeight()+$(".navbar-tps-placement").outerHeight())-4;
        $("#content").css("cssText", "height: "+height+"px; padding: 0 !important;");
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/filemanager.js